const SO = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%2085.333%20512%20341.333'%3e%3crect%20y='85.331'%20fill='%23338AF3'%20width='512'%20height='341.337'/%3e%3cpolygon%20fill='%23FFFFFF'%20points='256,157.273%20278.663,227.021%20352,227.021%20292.668,270.127%20315.332,339.876%20256,296.769%20196.668,339.876%20219.332,270.127%20160,227.021%20233.337,227.021%20'/%3e%3c/svg%3e";
export {
  SO as default
};
//# sourceMappingURL=SO.svg.es.js.map
